import { StackFrame } from '@fullstory/recording-api';

export const CONSOLE_EMPTY = 0;
export const CONSOLE_LOG = 1;
export const CONSOLE_WARN = 2;
export const CONSOLE_ERROR = 3;

export enum LogLevel {
  All = 'all',
  Logs = 'log',
  Info = 'info',
  Warnings = 'warn',
  Errors = 'error',
  Exception = 'exception',
}

export interface LogEntry {
  idx: number;
  pageOffset: number;

  level: string;
  messages: string[];
  source?: string;
  line?: number;
  stack?: StackFrame[];

  // Visual properties
  hidden: boolean; // Hidden if not matching the current client-side search criteria
}
